import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsGatewayService } from 'src/app/shared/services/gateway/notifications.gateway.service';
import { NotificationDto } from 'src/app/shared/interfaces/notifications/notification.interface';
import { ToastServiceService } from 'src/app/shared/services/toast-service.service';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'oms-notifications-popover',
  standalone: true,
  imports: [CommonModule, PaginatorModule],
  templateUrl: './notifications-popover.component.html',
  styleUrls: ['./notifications-popover.component.scss'],
})
export class NotificationsPopoverComponent implements OnInit {
  notifications: NotificationDto[] = [];
  loading = false;
  loadingPage = false;
  first = 0;
  readonly rows = 5;
  totalRecords = 0;

  constructor(
    private notificationsGateway: NotificationsGatewayService,
    private toastService: ToastServiceService
  ) {}

  ngOnInit(): void {
    this.loadNotifications(0);
  }

  loadNotifications(page: number, isPageChange: boolean = false): void {
    if (isPageChange) {
      this.setLoadingPage(true);
    } else {
      this.setLoading(true);
    }
    this.notificationsGateway.getList(page, this.rows).subscribe({
      next: (paged) => {
        this.notifications = paged.content;
        this.totalRecords = paged.totalElements;
        this.first = paged.number * paged.size;
        this.setLoading(false);
        this.setLoadingPage(false);
      },
      error: () => {
        this.toastService.showFail('Σφάλμα', 'Αποτυχία φόρτωσης ειδοποιήσεων.');
        this.setLoading(false);
        this.setLoadingPage(false);
      },
    });
  }

  onPageChange(event: PaginatorState): void {
    if (this.loadingPage) return;
    const page = event.page ?? 0;
    this.loadNotifications(page, true);
  }

  onNotificationClick(notification: NotificationDto): void {
    if (this.isDelivered(notification)) {
      return;
    }
    this.notificationsGateway.markAsDelivered(notification.id).subscribe({
      next: (updated) => this.updateNotificationInList(updated),
      error: () => this.toastService.showFail('Σφάλμα', 'Αποτυχία ενημέρωσης ειδοποίησης.'),
    });
  }

  formatDate(value: string | undefined): string {
    if (!value) return '';
    const date = new Date(value);
    return isNaN(date.getTime()) ? value : date.toLocaleString('el-GR');
  }

  isDelivered(notification: NotificationDto): boolean {
    return notification.status === 'delivered';
  }

  // ========================================
  // Private Helper Methods (Stepdown Order)
  // ========================================

  private setLoading(loading: boolean): void {
    this.loading = loading;
  }

  private setLoadingPage(loadingPage: boolean): void {
    this.loadingPage = loadingPage;
  }

  private updateNotificationInList(updated: NotificationDto): void {
    this.notifications = this.notifications.map((n) => (n.id === updated.id ? updated : n));
  }
}
